import site from '../seo/site.json';
import { locales } from '../seo/business';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './styles/SiteFooter.module.css';

const SiteFooter: React.FC = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith('/admin') || pathname === '/login') return null;

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brand}>
          <img src="/logo.png" alt="Familia García Vidal" width="64" height="64" loading="lazy" />
          <div>
            <strong>Familia García Vidal</strong>
            <span>Del campo a tu mesa.</span>
          </div>
        </div>

        <nav className={styles.links} aria-label="Navegación del pie de página">
          <Link to="/promociones">Promociones</Link>
          <Link to="/contacto">Contacto</Link>
          <Link to="/terminos">Términos y condiciones</Link>
          <Link to="/privacidad">Privacidad</Link>
          <Link to="/arrepentimiento">Botón de arrepentimiento</Link>
          <a href="https://www.argentina.gob.ar/defensadelconsumidor" target="_blank" rel="noreferrer">Defensa del Consumidor</a>
          <Link to="/productos">Productos</Link>
          <Link to="/envios">Envíos</Link>
          <Link to="/locales">Locales</Link>
          <Link to="/nosotros">Nosotros</Link>
          <Link to="/familia">Cliente fiel</Link>
        </nav>
        <address className={styles.contact}>
          <a href="mailto:pedidos@garciavidal.com">pedidos@garciavidal.com</a><br />
          <a href="https://wa.me/5493413080099">WhatsApp: +54 9 341 308-0099</a>
          {locales.map(local => <div key={local.id}><strong>{local.nombre}</strong>: {local.direccion}<br />{local.horario}</div>)}
        </address>
      </div>
      <div className={styles.legal}>© {new Date().getFullYear()} Familia García Vidal · {site.legalName} · CUIT {site.taxID} · Domicilio fiscal: {site.fiscalAddress}</div>
    </footer>
  );
};

export default SiteFooter;
